<template>
  <input
    ref="inputRef"
    v-bind="$attrs"
    class="input"
    :class="size"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script setup>
import {ref} from "vue";

defineOptions({inheritAttrs: false});
defineProps({
  modelValue: {type: String, default: ""},
  size: {type: String, default: "md"},
});
defineEmits(["update:modelValue"]);

const inputRef = ref(null);
defineExpose({focus: () => inputRef.value?.focus()});
</script>

<style scoped>
.input {
  font-family: inherit;
  font-weight: 700;
  line-height: 1;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 6px;
  outline: none;
  background: white;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.75);
  margin: 0;
  flex: 1;
  min-width: 0;
}
.input:focus {
  border-color: var(--brand-color);
}
.input::placeholder {
  font-weight: 300;
  font-style: italic;
  color: rgba(0, 0, 0, 0.4);
}
.input:focus::placeholder {
  color: rgba(0, 0, 0, 0.35);
}
.input.md {
  font-size: 17px;
  height: 22px;
  padding: 0 8px;
}
.input.sm {
  font-size: 14px;
  height: 20px;
  padding: 0 5px;
}
</style>
